<template>
  <div>
    <alert :errors="errors" css_class="ma-1"></alert>
    <list-table
      class="mt-12"
      :itemList="itemList"
      :canAddGroup="canAddGroup"
      @on-delete-group="onDeleteGroup"
      @on-attach-permission="onAttachPermission"
    ></list-table>
  </div>
</template>

<script>
import ListTable from "../components/group-edits/list-table.vue";
import Alert from "../components/common/alert.vue";
import AlertBuilder from "../logic/common/alert-contents";
import Api from "@/logic/api/api.js";
import valueMapper from "../logic/common/value-mapper";
import Roles from "@/logic/common/roles";
export default {
  components: {
    "list-table": ListTable,
    alert: Alert,
  },
  computed: {
    itemList() {
      return this.$store.getters.manageGroupList;
    },
  },
  data() {
    this.$nextTick(() => {
      this.reloadData();
    });
    return {
      errors: [],
      canAddGroup: false,
    };
  },
  methods: {
    /**
     * グループを一覧で取得する
     */
    reloadData() {
      // グループ一覧を取得する
      this.$store.commit("setWaiting", true);

      const apiRequests = [];
      const processList = [];

      // グループ情報を取得する
      apiRequests.push("group.list");
      processList.push(
        Api.call("/admin/group", {
          purpose: "GROUP_TREE_READABLE",
        })
      );

      // 親グループになることのできるグループの情報を取得する
      apiRequests.push("group.parent");
      processList.push(
        Api.call("/admin/group", {
          purpose: "GROUP_MANAGEMENT",
          no_detail: true,
        })
      );

      Promise.all(processList)
        .then((result) => {
          this.$store.commit("setWaiting", false);
          //APIから取得した結果を画面に表示する
          let groupList = [];
          if (apiRequests.includes("group.list")) {
            groupList = result[apiRequests.indexOf("group.list")].group_list;
          }
          // 親グループになることのできるグループを取得する
          this.canAddGroup = false;
          if (apiRequests.includes("group.parent")) {
            if (
              result[apiRequests.indexOf("group.parent")].group_list.length >= 1
            ) {
              // 1件以上の親グループがあれば、追加ボタンを有効にする
              this.canAddGroup = true;
            }
          }

          this.$store.commit(
            "setManageGroupList",
            groupList.map((group) => {
              return {
                groupId: group.group_id,
                groupName: group.display_name,
                parentGroup: group.parent_group.display_name,
                admin: group.join
                  .filter((user) => Roles.isAdmin(user.role))
                  .map((user) => {
                    return {
                      name: user.display_name,
                      color: Roles.roleToRoleColor(user.role),
                      detail: user.email,
                    };
                  }),
                user: group.join
                  .filter((user) => Roles.isReader(user.role))
                  .map((user) => {
                    return {
                      name: user.display_name,
                      color: Roles.roleToRoleColor(user.role),
                      detail: user.email,
                    };
                  }),
                groupEdit: {
                  editable: group.control_permission.editable,
                },
              };
            })
          );
        })
        .catch((result) => {
          this.$store.commit("setWaiting", false);
          Api.resolve(result);
        });
    },
    /**
     * メッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * 権限を付与する
     */
    onAttachPermission(selected, mail_address, role) {
      // 送信パラメータを作成する
      const postData = selected.map((group) => {
        return {
          ...role,
          owner: {
            mail_address: mail_address,
          },
          destination: {
            group_id: group.groupId,
          },
        };
      });
      this.clearMessage();
      this.$nextTick(() => {
        //権限を付与する
        this.$store.commit("setWaiting", true);
        Api.repeatCall("/admin/permission/create", postData)
          .then(() => {
            this.$store.commit("setWaiting", false);
            // 削除に成功した
            this.errors.push(AlertBuilder.success("権限を付与しました"));
            this.reloadData();
          })
          .catch((result) => {
            this.$store.commit("setWaiting", false);
            const message = valueMapper
              .map({
                400: AlertBuilder.error("対象のメールアドレスが存在しません"),
                403: AlertBuilder.error("権限がありません"),
                409: AlertBuilder.error(
                  "同じ権限を重複して付与することはできません"
                ),
              })
              .get(result.status);
            if (message) {
              this.errors.push(message);
            } else {
              Api.resolve(result);
            }
          });
      });
    },
    /**
     * グループを削除する
     */
    onDeleteGroup(selected) {
      const deletedMap = {};
      // 送信パラメータを作成する
      const postData = {
        delete_request: selected.map((group) => {
          deletedMap[group.groupId] = group.groupName;
          return {
            group_id: group.groupId,
          };
        }),
      };
      this.clearMessage();
      this.$nextTick(() => {
        // グループを削除する
        this.$store.commit("setWaiting", true);
        Api.call("/admin/group/delete", postData)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            const message = valueMapper
              .map({
                success: AlertBuilder.success("削除しました"),
                failed: AlertBuilder.error("削除に失敗しました"),
              })
              .get(result.message);
            if (message) {
              this.errors.push(message);
            }
            if (result.failed) {
              result.failed.forEach((info) => {
                this.errors.push(
                  AlertBuilder.error(
                    `[${deletedMap[info.uid]}]:${info.reason.jp}`
                  )
                );
              });
            }
            this.reloadData();
          })
          .catch((result) => {
            this.$store.commit("setWaiting", false);
            Api.resolve(result);
          });
      });
    },
  },
};
</script>

<style></style>
